import { useEffect } from "react";
import { init, reactRouterV7BrowserTracingIntegration } from "@sentry/react";
import { useFlagsStatus, useFlag } from "@unleash/proxy-client-react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router";
import { SENTRY_ENABLED_FLAG } from "@topi/shared/platform/feature-flags/constants";

const IGNORED_RESOURCE_SPAN_OPS = [
  "resource.script",
  "resource.other",
  "resource.link",
  "resource.img",
  "resource.css",
  "resource.iframe",
  "resource.beacon",
  "resource.icon",
];

export function useInitSentry(): void {
  const { flagsReady } = useFlagsStatus();

  const isSentryEnabled = useFlag(SENTRY_ENABLED_FLAG);

  useEffect(() => {
    if (!flagsReady || !isSentryEnabled) {
      return;
    }

    if (
      !import.meta.env.SENTRY_DSN ||
      import.meta.env.SENTRY_DSN === "" ||
      !import.meta.env.SENTRY_RELEASE ||
      import.meta.env.SENTRY_RELEASE === ""
    ) {
      return;
    }

    init({
      dsn: import.meta.env.SENTRY_DSN,
      environment: import.meta.env.MODE,
      release: import.meta.env.SENTRY_RELEASE,
      integrations: [
        reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
          ignoreResourceSpans: IGNORED_RESOURCE_SPAN_OPS,
        }),
      ],
      tracesSampleRate: 0.2,
      denyUrls: [
        // Ignore all webkit-extension schemas
        /webkit-masked-url:/,
      ],
    });
  }, [flagsReady, isSentryEnabled]);
}
